import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { HeaderService } from '@app/core/services/header.service';
import { veeActionMenu } from '@views/vee/vee-list/vee.action-menu';
import { veeTable } from '@shared/table-configs/vee/vee.table';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { TableComponent } from '@shared/components/table/table.component';
import { AuthRoles, EstimationGroupSearchResult, EstimationGroupsService } from '@app/api/dmc';
import { ModalService } from '@app/core/services/modal.service';
import { LoadingService } from '@app/core/services/loading.service';
import { VeeCreateEditModalComponent } from '@shared/modals/vee/vee-create-edit-modal/vee-create-edit-modal.component';
import { CardComponent } from '@shared/components/card/card.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { Observable } from 'rxjs';
import { removeNullValues } from '@app/core/utils/remove-null-values';
import { SearchStorageService } from '@app/core/services/search-storage.service';
import { SortParam } from '@app/core/constants/sort-param';
import { hasRole } from '@app/core/guards/has-role.guard';

@Component({
  selector: 'app-vee-list',
  imports: [
    HeaderComponent,
    TranslatePipe,
    TableComponent,
    CardComponent,
    ReactiveFormsModule,
    ButtonDirective,
    InputGroupComponent,
    LabelDirective,
    InputDirective
  ],
  templateUrl: './vee-list.component.html',
  styleUrl: './vee-list.component.css'
})
export class VeeListComponent implements AfterViewInit {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  public searchForm: FormGroup = new FormGroup({
    name: new FormControl(),
  })

  /** * Selected elements in the list **/
  public selectedElements: any[] = [];

  /** Table configuration **/
  public tableConfig: TableConfig<EstimationGroupSearchResult> = {
   ...veeTable,
   serviceCallback: (pageSize: number, page: number, sort?: SortParam) => this.search(pageSize, page, sort),
  }

  /** Search Query **/
  public searchQuery: string = '';

  /** * Results from the VEE query **/
  public results: EstimationGroupSearchResult[] = [];

  constructor(
    private readonly headerMenuService: HeaderService,
    private readonly estimationGroupsService: EstimationGroupsService,
    private readonly modalService: ModalService,
    private readonly loadingService: LoadingService,
    private readonly searchStorageService: SearchStorageService,
  ) {
    const veeWriter = hasRole([AuthRoles.VEEWriter]);

      this.headerMenuService.setActions(
        veeActionMenu,
        {
          add: () => this.openAddModal(),
          edit: () => this.openEditModal()
        },
        {
          add: () => !veeWriter,
          edit: () => !veeWriter || this.selectedElements.length !== 1
        }
      );
  }

  public ngAfterViewInit(): void {
    if (this.searchStorageService.get()) {
      const params = this.searchStorageService.get();
      if (!params) return;
      this.searchForm.patchValue(params);

      this.table?.search();
    }
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
  const query = removeNullValues(this.searchForm.value);
  return this.estimationGroupsService.veeEstimationGroupsSearchPost({ ...query, page, pageSize })
  }

  public openAddModal(): void {
    this.modalService.show({
      component: VeeCreateEditModalComponent,
      title: 'vee.createModal.title',
      actions: [
        { type: 'primary', label: 'system.button.create', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
    }).subscribe(() => {
      this.table?.search()
    });
  }

  public openEditModal(): void {
    this.modalService.show({
      component: VeeCreateEditModalComponent,
      title: 'vee.editModal.title',
      actions: [
        { type: 'primary', label: 'system.button.edit', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        id: this.selectedElements[0].id,
        vee: this.selectedElements[0]
      }
    }).subscribe(() => {
      this.table?.search()
    })
  }

  public storeSearch(): void {
    this.searchStorageService.set(this.searchForm.value);
  }

}
